var CheckOutPath = "CheckOut";
var CheckOutAddressPath = "CheckOutAddress";
var CheckOutValidator = "CheckoutValidation";
var CheckoutPayment = "CheckoutPayment";
var isSingleLineCreditCard = false;

function ShowInstallmentByBankCode(BankCode, cardType, BankLogoPath) {

    var activeCls = $("#PaymentGroups .PaymentGroupItem.active:first input:first").attr("data-payment");

    $("#PosGroups .PosGroupItem").hide();

    switch (cardType) {

        case "Credit":
            if (activeCls != "KrediKarti") {

                AutoFillBankLogo = BankLogoPath;
                activeCls = "KrediKarti";

                $(".PaymentGroupSelectNew li").removeClass("active");
                $(".PaymentGroupSelectNew li a.KrediKarti").parent().addClass("active");
                $(".PaymentGroupSelectNew li a input").removeAttr("checked");
                $(".PaymentGroupSelectNew li a.KrediKarti input").attr("checked", "checked");
                $(".PaymentGroupSelectNew li a.KrediKarti input").trigger("change");

                if (BankLogoPath != undefined && BankLogoPath != "") {

                    $("div#CreditCardLogo > img").show();
                    $("div#CreditCardLogo > img").attr("src", "/ContentImages/Banks/" + BankLogoPath);
                }

            }
            break;

        case "Debit":
            if (activeCls != "DebitCard") {


                AutoFillBankLogo = BankLogoPath;

                activeCls = "DebitCard";

                $(".PaymentGroupSelectNew li").removeClass("active");
                $(".PaymentGroupSelectNew li a.DebitCard").parent().addClass("active");

                $(".PaymentGroupSelectNew li a input").removeAttr("checked");
                $(".PaymentGroupSelectNew li a.DebitCard input").attr("checked", "checked");

                //Debite Geçiş
                $(".PaymentGroupSelectNew li a.DebitCard input").trigger("change");

                if (BankLogoPath != undefined && BankLogoPath != "") {

                    $("div#CreditCardLogo > img").show();
                    $("div#CreditCardLogo > img").attr("src", "/ContentImages/Banks/" + BankLogoPath);

                }



            }

            break;

    }

    $(".Installments ul").hide();

    if (activeCls == "KrediKarti") {
        $(".Installments ul.InstallmentHeader").show();
    } else {
        $(".AllInstallments").hide();
        $("#PaymentBanners").hide();
    }

    //Banka kredi kartı title
    $(".Installments .BarInner span").hide();
    $(".Installments .BarInner span." + activeCls).show();

    var cardown = $("#CardOwner:first").val();

    //Amex ve ShopAndMiles Taksit gösterme, ama garantiden geç
    var isAmex = false;
    var isShopAndMiles = false;
    if (LastCardName.toUpperCase().indexOf("AMEX") > -1) isAmex = true;
    if (LastCardName.toUpperCase().indexOf("MASTER SM") > -1 || LastCardName.toUpperCase().indexOf("VISA SM") > -1) isShopAndMiles = true;
    if (isAmex || isShopAndMiles) BankCode = "62";

    //Banka koduna ait taksit seçeneği varsa
    if ($(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "']").length > 0 && cardown.toUpperCase() != "ENVER GÖKMEN1") {

        $("#PosGroups .PosGroupItem[data-rel='" + BankCode + "']").show();
        $("#PosGroups .PosGroupItem[data-rel='" + BankCode + "']").addClass("active");

        $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "']").show();
        $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "'] li").show();

        //Pos başlık logo ile birlikte göster/gizle hide olduğunda sadece taksitler görünür.
        $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "'] .PosHeader").show();
        $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "'] li.FirstInstallment:first input").attr("checked", "checked");
        $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "'] li.FirstInstallment:first input").trigger("change");
        $(".Installments ul.InstallmentHeader").show();

        if (isAmex || isShopAndMiles) {

            $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "'] li").hide();
            $(".Installments ul[data-rel='" + BankCode + "'][data-cardtype='" + activeCls + "'] li.FirstInstallment").show();

        }

    }
    else {

        //Banka koduna ait taksit seçeneği YOKSA tek çekim göster 
        if (cardown != "ENVER GÖKMEN1") {

            // console.log("activeCls:", activeCls, " BankCode:", BankCode);

            $("#PosGroups .PosGroupItem[data-webposid='other']").show();
            $("#PosGroups .PosGroupItem[data-webposid='other']").addClass("active");

            $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "'] li").hide();
            $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "'] .PosHeader").hide();
            $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "']:first").show();
            $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "'] li.FirstInstallment:first").show();
            $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "'] li.FirstInstallment:first input").attr("checked", "checked");
            $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "'] li.FirstInstallment:first input").trigger("change");
            $(".Installments ul.InstallmentHeader").hide();

        }
        else {
            //--------------------------------------------------------------------------------------------------------------------- 
            //Banka koduna ait taksit seçeneği YOKSA tüm taksitleri göster 
            $(".Installments ul[data-cardtype='" + activeCls + "']").show();
            $(".Installments ul[data-cardtype='" + activeCls + "'] li").show();
            $(".Installments ul[data-cardtype='" + activeCls + "'] .PosHeader").show();
            $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "'] li.FirstInstallment:first input").attr("checked", "checked");
            $(".Installments ul.DefaultPos[data-cardtype='" + activeCls + "'] li.FirstInstallment:first input").trigger("change");
        }


    }


}

var firstBin = "";
var lastBin = "";
var AutoFillCard1 = "";
var AutoFillBankCode = "-1";
var AutoFillCard2 = "";
var AutoFillName = "";
var AutoFillBankLogo = "";
var LastCardName = "";

function CheckBinNumber(t, t_1, t_2) {

    var t_1 = $("#CardNumbers > input#CardNumber1").val().replace(/\D/g, '');
    var t_2 = $("#CardNumbers > input#CardNumber2").val().replace(/\D/g, '');
    var t_3 = $("#CardNumbers > input#CardNumber3").val().replace(/\D/g, '');
    var t_4 = $("#CardNumbers > input#CardNumber4").val().replace(/\D/g, '');

    var t = (t_1 + t_2);

    if (t.length >= 8 && (isSingleLineCreditCard || (t_1.length == 4 && t_2.length >= 4))) {

        var tval6 = t.substring(0, 8);
        lastBin = tval6;

        if (lastBin != firstBin) {

            $.ajax({
                url: "/" + CheckoutPayment + "/CardDetails",
                dataType: 'json',
                async: true,
                data: "BinNo=" + tval6,
                success: function (jsonReturn) {

                    if (jsonReturn.length !== 0) {

                        $.each(jsonReturn, function (index, element) {
                            var ax = (element.ID + "-");

                            $("div#CreditCardLogo > img").show();
                            $("div#CreditCardLogo > img").attr("src", "/ContentImages/Banks/" + element.BankLogoPath);

                            bnkCode = element.BankCode;
                            cardType = element.CardType;
                            AutoFillBankCode = bnkCode;
                            var LogoPath = element.BankLogoPath;

                            if (element.CardLogoPath != undefined && element.CardLogoPath.length > 0) {
                                LogoPath = element.BankLogoPath;
                            }

                            LastCardName = element.CardName;
                            ShowInstallmentByBankCode(bnkCode, cardType, LogoPath);


                        });

                    }
                    else {

                        bnkCode = "-1";
                        AutoFillBankCode = "-1";
                        ShowInstallmentByBankCode(bnkCode, -1, "");
                    }


                }


            });

            firstBin = lastBin;

        }
    }
}



function formatCC(value) {
    var v = value.replace(/\s+/g, '').replace(/[^0-9]/gi, '')
    var matches = v.match(/\d{4,16}/g);
    var match = matches && matches[0] || ''
    var parts = []
    for (i = 0, len = match.length; i < len; i += 4) {
        parts.push(match.substring(i, i + 4))
    }
    if (parts.length) {
        return parts.join(' ')
    } else {
        return value
    }
}

function validateCardNumber(number) {
    var regex = new RegExp("^[0-9]{16}$");
    if (!regex.test(number))
        return false;

    return luhnCheck(number);
}

function luhnCheck(val) {
    var sum = 0;
    for (var i = 0; i < val.length; i++) {
        var intVal = parseInt(val.substr(i, 1));
        if (i % 2 == 0) {
            intVal *= 2;
            if (intVal > 9) {
                intVal = 1 + (intVal % 10);
            }
        }
        sum += intVal;
    }
    return (sum % 10) == 0;
}

function IsNumeric(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}

function ReloadOnTimeOut(dt) {

    if (dt != undefined) {

        //timeout no state found reload
        if (dt.StatusText == "CheckOutStateTimeOut" || dt.StatusText == "Reload") {

            $(".AjaxLoader").show();
            document.location.reload(true);
        }
    }
}

function PrepareAddressAndPayment() {

    if ($("#CurStep").length > 0) {


        var step = $("#CurStep").val();

        var url = "";

        if (step == "Sepet") {
            url = "/" + $("#SmallLangCode").val() + "/p/CheckOutAddress/PrepareUserAdresses";
        }

        if (step == "Adres") {
            url = "/" + $("#SmallLangCode").val() + "/p/CheckOutPayment/PreparePayment";
        }

        if (url.length > 0) {
            $.ajax({
                type: 'post',
                url: url,
                success: function (dt) {

                }
            });
        }

    }
}


function SetPaymentType(webPosInstallmentID, BankID) {

    if (BankID == undefined) { BankID = 0; }

    $.ajax({
        type: 'post',
        url: "/" + $("#SmallLangCode").val() + "/p/CheckOutPayment/SetPaymentType?webPosInstallmentID=" + webPosInstallmentID + "&bankID=" + BankID,
        success: function (dt) {

            ReloadOnTimeOut(dt);

            if (dt.Status) {

                RefreshOrderSummary(false, false);

            } else {

                SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
            }
        }

    });

}

function ReloadPage() {

    $(".AjaxLoader").show();
    $(".container").css("opacity", "0.5");
    document.location.reload(true);

}

function SetErrorResults(target, errors, clear, slideDown) {


    $('html,body').animate({ scrollTop: 0 }, 'slow', function () { });

    if (clear) {
        $(target).html("");
    }

    if (errors != undefined && errors.length > 0) {

        for (var i = 0; i < errors.length; i++) {

            $(target).append(errors[i] + "<br />");
        }

        if (slideDown) {

            $(target).show();
        }
        else {
            $(target).show();
        }
    }

}

function GetAddressForm(url) {

    if ($("#AddressArea").length > 0) {

        $.ajax({
            type: "GET",
            cache: false,
            url: url,
            success: function (dt) {

                ReloadOnTimeOut(dt);
                $("#AddressArea").html(dt);
                HandleAddressInputs();

            }
        });

    }
}

function RefreshOrderSummary(animateTop, showCouponLine) {


    $.ajax({
        type: 'get',
        cache: false,
        url: "/" + $("#SmallLangCode").val() + "/p/" + CheckOutPath + "/summary",
        success: function (dt) {
            $("#OrderSummary").html(dt);

            if (showCouponLine) {

                $(".CouponLine").hide();
                $(".CouponLine").show("slow");

                if ($("#CouponModal").length > 0) {
                    $("#CouponModal").modal("hide");
                }
            }

            if (animateTop) {
                $('html,body').animate({ scrollTop: 2000 }, 'slow', function () { });
            }

        }

    });



}

function RefreshCargoList() {

    $.ajax({
        type: 'get',
        url: "/" + $("#SmallLangCode").val() + "/p/CheckOutAddress/GetCargoList",
        success: function (dt) {
            $("#CargoList").html(dt);
        }

    });
}

function HandleAddressInputs() {

    if ($(".OrderAdressForm").length > 0) {

        if ($(".OrderAdressForm #Phone2").length > 0) {

            console.log($(".OrderAdressForm #Phone2").text().length);

            if ($(".OrderAdressForm #Phone2").val().length <= 0) {
                $(".OrderAdressForm #Phone2").val("0");
            }

            $(".OrderAdressForm #Phone2").mask("0999 999 99 99");
        }
    }
}

function UseCoupon(couponCode) {

    $.ajax({
        type: 'get',
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        url: "/" + $("#SmallLangCode").val() + "/p/CheckOutCart/AddCoupon?couponCode=" + couponCode,
        success: function (dt) {

            ReloadOnTimeOut(dt);

            if (dt.Status == true) {
                //Sipariş özetini Yenile
                RefreshOrderSummary(true, true);

                $("#OrderCoupons tr").removeClass("added");
                $("#OrderCoupons tr button[data-value=" + couponCode + "]").closest("tr").addClass("added");

            }
            else {

                SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
            }
        }

    });

}

function SetCreditCartAndStep(adim, href) {

    if ($("#CardForm").length > 0) {

        $form = $("#CardForm");

        $.ajax({
            type: 'post',
            async: true,
            cache: false,
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutPayment/SetCreditCard",
            data: $form.serialize(),
            success: function (dt) {

                ReloadOnTimeOut(dt);

                if (dt.Status == true) {

                    SetStep(adim, href);
                    //Sipariş özetini Yenile
                    //RefreshOrderSummary(true, true); 
                }
                else {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
                }

            }

        });



    }
}

function SetStepDataLayer() {

    $.ajax({
        type: 'POST',
        cache: false,
        url: "/tr/p/CheckoutValidation/SetStep?step=Adres",
        data: "",
        success: function (dt) {

            ReloadOnTimeOut(dt);

            if (dt.Status == true) {

                if (dt.StatusText == "AdresStep") {

                    if (dt.Result != undefined) {

                        var obj = JSON.parse(dt.Result);

                        ga('ec:setAction', 'checkout_option', {
                            'step': 3,
                            'option': 'Aras Kargo'
                        });

                        ga('send', 'event', 'Checkout', 'Option', {
                            hitCallback: function () {
                                // Advance to next page.
                            }
                        });
                    }
                    $("#LoginRegisterModal").modal("show");
                }

            }
        }
    });

}


function SetStep(adim, href) {
    if (typeof adim != 'undefined') {


        var OrdNote = "";
        if ($("#OrderNoteText").length > 0) {
            OrdNote += "OrderNote=" + $("#OrderNoteText").val();
        }

        $.ajax({
            type: 'POST',
            cache: false,
            url: "/" + SmallLangCode + "/p/" + CheckOutValidator + "/SetStep?step=" + adim,
            data: OrdNote,
            success: function (dt) {

                ReloadOnTimeOut(dt);

                if (dt.Status == false) {

                    //ask for login or memberless
                    if (dt.StatusText == "AskForLogin") {

                        $("#LoginRegisterModal").modal("show");
                    }

                    //Edit Address Or Create Address
                    if ($("#AddressArea").length > 0 && (dt.StatusText == "MissingAddress" || dt.StatusText == "InvalidAddress")) {

                        var url = "/" + $("#SmallLangCode").val() + "/p/" + CheckOutAddressPath + "/EditOrCreate?id=0";
                        //console.clear();
                        //console.log(id);

                        GetAddressForm(url);

                    } else if (dt.Status == false) {

                        SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
                    }

                }


                if (dt.Status == true) {

                    $("#Steps button, #Steps .StepName, #nextbtn, .Bottom #nextbtn, #backbutton, .Bottom #backbutton").attr("disabled", "disabled");
                    //$("#Steps button, #Steps .StepName, #nextbtn, .Bottom #nextbtn, #backbtn, .Bottom #backbtn").attr("disabled", "disabled");

                    //hata yoksa ve progress ise bekleyinizi göster
                    if (adim == "progress") {

                        $("#nextbtn, .Bottom #nextbtn, #backbutton,  .Bottom #backbutton").text($("#PleaseWait").val());
                        // $("#nextbtn, .Bottom #nextbtn, #backbtn,  .Bottom #backbtn").text($("#PleaseWait").val());

                        $(".AjaxLoaderDiv").css("left", "44%");

                    }

                    //goto next step
                    document.location.href = "/" + SmallLangCode + "/p/" + CheckOutPath + "/" + adim;

                }
            }

        });
    }
}

function ToggleAgreements() {
    $(".AgreementHeader").on("click", function () {
        $(this).next(".toggle").slideToggle();
        $(this).find("i").toggleClass("minus-icon");

    });
}


function goHome() {
    $("#backbtn").on("click", function () {
        window.location = "/";
    }
    )
}

$(document).ready(function () {

    PrepareAddressAndPayment();
    ToggleAgreements();

    goHome();

    if ($(".SingleLineCart").length > 0) {
        isSingleLineCreditCard = true;
    }



    //SetStep Validate and Navigate
    $("body").on("click", "#Steps button, #Steps .StepName, #nextbtn, #backbtn", function () {

        var adim = $(this).attr("data-next");
        var href = $(this).attr("data-href");

        if (href != undefined && href != "") {
            document.location.href = href;
            return;
        }

        if ($(".PaymentDetail.KrediKarti").hasClass("active") && adim == "progress") {
            SetCreditCartAndStep(adim, href);

        } else {
            SetStep(adim, href);
        }



    });


    $("#LoginRegisterModal").on("click", ".ContinueWithoutMember", function (e) {

        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + "/p/" + CheckOutValidator + "/SetMemberless?memberless=true",
            success: function (dt) {

                ReloadOnTimeOut(dt);

                if (dt.Status == true) {

                    //SetStep(adim, href);
                    //Sipariş özetini Yenile
                    //RefreshOrderSummary(true, true); 
                }
                else {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
                }

            }

        });

        return false;
        e.preventDefault();

    });


    //Cart Change Delete 
    $('input.sepetAdet').keyup(function () {

        var updateID = $(this).attr("data-id");
        var yeniAdet = $(this).val();
        var adetKutusu = $(this);
        var LangID = $("#LangID").val();

        if (yeniAdet <= 1) {
            $(adetKutusu).val(1);
        }
        else if (yeniAdet >= 9) {
            $(adetKutusu).val(9);
        }

        //update'den Sonra
        var sepetToplami = 0;


        var ToplamAdet = $("#ustSepetAdet").html();

        var guncellenecekContainerObje = $(this).parent().parent();

        $(guncellenecekContainerObje).find(".ustSepetAjaxLoader").show();
        $(guncellenecekContainerObje).find(".ustSepetDelete").hide();

        $(guncellenecekContainerObje).css("opacity", "0.5");

        $.ajax({
            type: 'get',
            url: '/Cart/UpdateCartAmount',
            data: 'id=' + updateID + "&adet=" + yeniAdet + "&langID=" + LangID,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            cahce: false,
            success: function (dt) {

                if (dt.Sonuc == true) {

                    document.location.reload(true);

                }
                else {

                    alert(dt.IslemSonucAciklama);
                }

                $(guncellenecekContainerObje).find(".ustSepetAjaxLoader").hide();
                $(guncellenecekContainerObje).find(".ustSepetDelete").show();
                $(guncellenecekContainerObje).css("opacity", "1");


            }
        });


        //ISNUMERIC ADET SONU

    });

    //Amount Option Change
    $('.BasketDetails .GenMinus, .BasketDetails .GenPlus').click(function () {

        $SepetAdet = $(this).closest(".BasketDetails").find("input.sepetAdet");
        if ($(this).hasClass("GenPlus") == true) {
            if ($SepetAdet.val() >= 9) {

                $SepetAdet.val(parseInt(9));
            }
            else {

                $SepetAdet.val(parseInt($SepetAdet.val()) + 1);
            }
        }
        else {

            $SepetAdet.val(parseInt($SepetAdet.val()) - 1);
        }

        if ($SepetAdet.val() != "0") {

            $SepetAdet.trigger('keyup');
        }
        else {

            $SepetAdet.val(1)
        }

    });

    $("#OrderBasket .RemoveIcon").click(function () {

        var Silid = $(this).attr("data-id").replace("sepetsil", "");
        var LangID = $("#LangID").val();

        $(this).closest("tr").css("opacity", "0.5");

        $.ajax({
            type: 'get',
            url: "/" + $("#SmallLangCode").val() + '/p/Cart/RemoveFromCart',
            data: 'id=' + Silid + "&langID=" + LangID,
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: function (dt) {

                //ReloadOnTimeOut(dt);

                if (dt.Sonuc == false) {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);

                } else {
                    ReloadPage();
                }
            }
        });


    });

    //COUPON
    $("#CouponForm").submit(function (e) {

        couponCode = $("#CouponCodeInput", $(this)).val();

        UseCoupon(couponCode);

        e.preventDefault();
        return false;
    });

    $("body .UsetCouponTd").click(function (e) {

        couponCode = $(this).attr("data-value");

        UseCoupon(couponCode);

        e.preventDefault();
        return false;
    });

    $("body").on("click", ".RemoveCoupon", function (e) {

        $.ajax({
            type: 'post',
            url: "/" + $("#SmallLangCode").val() + '/p/CheckOutCart/RemoveCoupon',
            contentType: "application/json; charset=utf-8",
            dataType: 'json',
            success: function (dt) {

                if (dt.Sonuc == false) {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);

                } else {

                    RefreshOrderSummary(false, false);
                    $("#OrderCoupons tr").removeClass("added");
                }
            }
        });

        e.preventDefault();
        return false;

    });

    //END CCOUPON

    //Adress Create And Edit
    $("body").on("click", ".AdresPopup", function () {

        var url = $(this).attr("data-href");

        GetAddressForm(url);

    });



    $("#OrderAdress").on("click", ".RemoveIcon", function () {

        $(this).closest("tr").css("opacity", "0.5");
        var id = $(this).attr("data-id");

        var url = "/" + $("#SmallLangCode").val() + "/p/" + CheckOutAddressPath + "/Delete?adresid=" + id;

        $.ajax({
            type: 'post',
            url: url,
            dataType: 'json',
            success: function (data) {

                ReloadOnTimeOut(data);

                if (data.Status == true) {

                    $("#OpStatusBar div.alert-success ul li").html(data.ResultDescription[0]);
                    $("#OpStatusBar > div.alert-sucess ").show();

                    ReloadPage();

                }
                else {

                    SetErrorResults($("#OpStatusBar div.alert-danger ul li"), data.ResultDescription, true, false);
                    $("#OpStatusBar > div.alert-danger ").show();
                }

            },
            error: function (data) {

                $("#Errors .alert-error").html(data.ResultDescription[0]);
            }
        });


    });


    $("body").on("change", ".ddl_ulke", function () {

        var seciliUlkeID = $(this).val();
        $(".ajaxilce").show();

        $.ajax({
            type: 'get',
            url: '/User/GetCities',
            data: 'countryid=' + seciliUlkeID,
            dataType: 'json',
            success: function (dt) {

                var icerik = "";

                $('#CityID option').remove();
                $('.ddl_sehir option').remove();
                $('.ddl_ilce option').remove();
                $('.ddl_mahalle option').remove();

                $('#CityID')
                    .append($("<option selected='selected'></option>")
                        .attr("value", "")
                        .text("Lütfen Seçin"));


                $('#CityID').parent().find("span").html("Lütfen Seçin");

                for (var i = 0; i < dt.length; i++) {


                    $('#CityID')
                        .append($("<option></option>")
                            .attr("value", dt[i].ID)
                            .text(dt[i].Name));

                }

                $(".ajaxilce").hide();


            }
        });

        RefReshCityAndTowns();

    });

    $("body").on("change", ".ddl_sehir", function () {

        var seciliSehirOID = $(this).val();
        $(".ajaxilce").show();

        $.ajax({
            type: 'get',
            url: '/User/GetTowns',
            data: 'cityid=' + seciliSehirOID,
            dataType: 'json',
            success: function (dt) {

                var icerik = "";
                $('#TownID option').remove();

                $('#TownID')
                    .append($("<option selected='selected' ></option>")
                        .attr("value", "")
                        .text("Lütfen Seçin"));


                $('#TownID').parent().find("span").html("Lütfen Seçin");

                for (var i = 0; i < dt.length; i++) {

                    $('#TownID')
                        .append($("<option></option>")
                            .attr("value", dt[i].ID)
                            .text(dt[i].Name));

                }

                $(".ajaxilce").hide();


            }
        });


    });

    $("body").on("change", ".ddl_ilce", function () {

        var seciliIlceID = $(this).val();
        $(".ajaxilce").show();

        $.ajax({
            type: 'get',
            url: '/User/GetQuarters',
            data: 'TownID=' + seciliIlceID,
            dataType: 'json',
            success: function (dt) {

                var icerik = "";
                $('#QuarterID option').remove();

                $('#QuarterID')
                    .append($("<option selected='selected' ></option>")
                        .attr("value", "")
                        .text("Lütfen Seçin"));


                $('#QuarterID').parent().find("span").html("Lütfen Seçin");

                for (var i = 0; i < dt.length; i++) {

                    $('#QuarterID')
                        .append($("<option></option>")
                            .attr("value", dt[i].ID)
                            .text(dt[i].Name));

                }

                $(".ajaxilce").hide();


            }
        });


    });

    $("#AddressArea").on("submit", "form.OrderAdressForm", function (e) {

        $form = $(this);
        $("#OpStatusBar div").hide();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            cache: false,
            success: function (data) {

                ReloadOnTimeOut(data);

                if (data.Status == true) {

                    $("#OpStatusBar div.alert-success ul li").html(data.ResultDescription[0]);
                    $("#OpStatusBar > div.alert-sucess ").show();

                    ReloadPage();

                }
                else {

                    SetErrorResults($("#OpStatusBar div.alert-danger ul li"), data.ResultDescription, true, false);
                    $("#OpStatusBar > div.alert-danger ").show();
                }

            },
            error: function (data) {

                $("#Errors .alert-error").html(data.ResultDescription[0]);
            }

        });

        e.preventDefault();
        return false;

    });

    var deliverCheckedVal = 0;
    var billingCheckedVal = 0;

    if ($("#OrderAdress input[name=adr_del]:checked").length > 0) {
        deliverCheckedVal = $("#OrderAdress input[name=adr_del]:checked").val();
    }

    if ($("#OrderAdress input[name=adr_bil]:checked").length > 0) {

        billingCheckedVal = $("#OrderAdress input[name=adr_bil]:checked").val();
    }

    //SetAdres
    $("#OrderAdress").on("change", "input[type=radio]", function (e) {

        var adrtype = $(this).attr("data-adrtype");
        var id = $(this).val();
        $clicked = $(this);

        $.ajax({
            type: 'post',
            url: "/" + $("#SmallLangCode").val() + "/p/" + CheckOutAddressPath + "/SetAddress?addressID=" + id + "&addressType=" + adrtype,
            success: function (dt) {

                ReloadOnTimeOut(dt);

                if (dt.Status) {

                    //Sipariş özetini Yenile
                    RefreshOrderSummary(false, false);
                    //KargoListesini Yenile 

                    if (adrtype == "Delivery") {
                        RefreshCargoList();
                    }

                    $("#AddressArea").html("");
                }

                if (dt.Status == false && dt.StatusText == "InvalidAddress" && $("#AddressArea").length > 0) {

                    var url = "/" + $("#SmallLangCode").val() + "/p/" + CheckOutAddressPath + "/EditOrCreate?id=" + id;

                    GetAddressForm(url);

                } else if (dt.Status == false) {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);
                }

                if (dt.Status == false) {

                    //Remove Checked Status Before go
                    if (adrtype == "Delivery") {

                        $("#OrderAdress input[name=adr_del]").removeAttr("checked");
                        $("#OrderAdress input[name=adr_del][value=" + deliverCheckedVal + "]").prop("checked", "checked");

                    } else if (adrtype == "Billing") {

                        $("#OrderAdress input[name=adr_bil]").removeAttr("checked");
                        $("#OrderAdress input[name=adr_bil][value=" + billingCheckedVal + "]").prop("checked", "checked");

                    }
                }
                else {

                    if (adrtype == "Delivery") {

                        deliverCheckedVal = id;

                    } else if (adrtype == "Billing") {

                        billingCheckedVal = id;

                    }

                }
            }

        });

    });

    //SetKargo

    var selectedCargoPriceID = 0;

    if ($("#CargoTable input:checked").length > 0) {
        selectedCargoPriceID = $("#CargoTable input:checked").val();
    }

    //$("body").on("click", "#OrderAdress td", function () {

    //    $lbl = $(this).find("label");

    //    console.log($lbl.length);

    //    if ($lbl.length <= 0) {

    //        $(this).closest("tr").find("label").trigger("click");
    //    } 
    //});

    $("body").on("click", "#CargoTable td", function () {

        $lbl = $(this).find("label");

        console.log($lbl.length);

        if ($lbl.length <= 0) {

            $(this).closest("tr").find("label").trigger("click");
        }
    });

    $("#GiftTable").on("change", "input", function () {

        var wantGift = $(this).is(":checked");

        console.log("gift status : ", wantGift);

        $.ajax({
            type: 'post',
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutCart/SetGift?wantGift=" + wantGift,
            success: function (dt) {

                ReloadOnTimeOut(dt);

                if (dt.Status == true) {

                    RefreshOrderSummary();

                }
                else {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);

                    $("#GiftTable input").removeProp("checked");
                    $("#GiftTable input[value=" + selectedCargoPriceID + "]").prop("checked", "checked");
                }
            }

        });

    });


    $("body").on("click", "#GiftTable td:not(.RadioTd)", function (e) {

        console.log("tr clicked");

        $radinput = $(this).closest("tr").find("input:first");
        $radinput.prop("checked", !$radinput.is(":checked"));
        $(this).closest("tr").find("input").trigger("change");

    });


    $("body").on("change", "#PaymentGroups input, .WebPosItem input, #BankList input, #PayAtDoor input", function (e) {

        $label = $(this).closest("label");
        $input = $(this);

        var paymentType = $input.attr("data-payment");
        var paymentTypeValue = $input.val();

        var webposinstallmentid = $input.attr("data-webposinstallment-id");
        var bankid = $input.attr("data-bankid");

        $("#PaymentGroups input").removeProp("checked");
        $("#PaymentGroups label, .TaksitLabel").removeClass("active");

        $label2 = $("#PaymentGroups label input[data-payment='" + paymentType + "']:first").closest("label");


        $label.addClass("active");
        $label2.addClass("active");

        $label.find("input").prop("checked", "checked");



        $(".PaymentDetail").removeClass("active");
        $(".PaymentDetail." + paymentType).addClass("active");

        if ($(this).closest("#PaymentGroups").length > 0) {

            $("#Erros").html("");
            $("#Erros").hide();
            $(".WebPosItem").hide();

            var webPosId = $(".WebPosItem.active").attr("data-webposid");

            $(".WebPosItem[data-webposid='" + webPosId + "']").show();
            //$(".WebPosItem[data-cardtype='" + paymentType + "']").show();


        }

        SetPaymentType(webposinstallmentid, bankid);

    });


    $("body").on("click", ".PosGroupItem", function (e) {
        $(".PosGroupItem").removeClass("active");
        $(this).addClass("active");
        var webPosId = $(this).attr("data-webposid");

        $(".WebPosItem").hide();
        $(".WebPosItem[data-webposid='" + webPosId + "']").show();

    });

    $("body").on("keyup", "#CardNumbers input", function (e) {

        var cr_1 = $("#CardNumbers > input#CardNumber1").val().replace(/\D/g, '');
        cr_1 = formatCC(cr_1);
        $("#CardNumbers > input#CardNumber1").val(cr_1);

        var cardNumber = cr_1.replace(/\D/g, '');

        isAllValid = false;

        if (cardNumber.length == 16 && validateCardNumber(cardNumber) == false) {

            $("#CardNumbers > input").addClass("NotValid");
            isAllValid = false;

        } else {
            $("#CardNumbers > input").removeClass("NotValid");
            isAllValid = true;
        }


        if (IsNumeric($(this).val().replace(/\D/g, '')) == false && $(this).val() != "" && $(this).hasClass("cardno")) {

            $(this).addClass("NotValid");
        }
        else {

            if (isAllValid || cardNumber.length < 16 || !$(this).hasClass("cardno")) {
                $(this).removeClass("NotValid");
            }

            if (isAllValid) {
                $("#CardNumbers > input").removeClass("NotValid");
            }
        }



        CheckBinNumber();

        //if ($(this).attr("id") == "CardOwner" && IsNumeric($(this).val().replace(/\D/g, ''))) {

        //    $(this).addClass("NotValid");
        //    $(".CardOwnerHeader").addClass("MoveNeeded");
        //}
        //else if ($(this).attr("id") == "CardOwner") {

        //    $(this).removeClass("NotValid");
        //    $(".CardOwnerHeader").removeClass("MoveNeeded");

        //}

    });


    $("#CargoTable").on("change", "input", function () {

        var id = $(this).val();
        $clicked = $(this);

        $.ajax({
            type: 'post',
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutAddress/SetCargoPrice?cargoPriceID=" + id,
            success: function (dt) {

                ReloadOnTimeOut(dt);

                if (dt.Status == true) {

                    RefreshOrderSummary();
                    selectedCargoPriceID = id;

                }
                else {


                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);

                    $("#CargoTable input").removeProp("checked");
                    $("#CargoTable input[value=" + selectedCargoPriceID + "]").prop("checked", "checked");

                }
            }

        });

    });

    $("body").on("change", "#AggrementApprove", function () {

        var IsApproved = $(this).is(":checked");

        $.ajax({
            type: 'post',
            url: "/" + $("#SmallLangCode").val() + "/p/CheckoutPayment/SetAgreement?isApproved=" + IsApproved,
            success: function (dt) {

                ReloadOnTimeOut(dt);

                if (dt.Status == true) {

                    RefreshOrderSummary();

                }
                else {

                    SetErrorResults($("#Erros"), dt.ResultDescription, true, true);

                }
            }

        });

    });



    //LOGIN & REGISTER
    var UseTagManager = false;
    $("body").on("submit", "form.UyeGiris", function () {

        $form = $(this);

        $("#LoginButton").attr("disabled", "disabled");
        $(".AjaxLoader").show();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                $(".AjaxLoader").hide();
                $("#LoginButton").removeAttr("disabled");

                if (dt.Sonuc == true) {

                    if (UseTagManager) {

                        AddUserAction("Login");
                    }

                    if (dt.JsonRs == "Reload") {

                        $("#AlertResult").removeClass("alert-danger");
                        $("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);

                        $(".AjaxLoader").show();
                        $form.hide();
                        $(".RwRegisterLogin").hide();

                        document.location.reload();

                    }

                    if (dt.JsonRs == "Redirect") {

                        $form.hide();
                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location = dt.Deger5;
                    }

                    $("#AlertResult").removeClass("alert-danger");

                    if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                        document.location = $("#register_FbRedirectUrl").val();
                    }


                }
                else {

                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-danger").show().find("span").html(dt.IslemSonucAciklama);
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });

    $("body").on("submit", "form.UyeOl", function () {

        $form = $(this);

        $("#LoginButton").attr("disabled", "disabled");
        $(".AjaxLoader").show();

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            success: function (dt) {

                $(".AjaxLoader").hide();
                $("#LoginButton").removeAttr("disabled");

                if (dt.Sonuc == true) {

                    if (UseTagManager) {
                        AddUserAction("Signup");
                    }

                    if (dt.JsonRs == "Redirect") {

                        $form.hide();
                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location = "/";
                    }

                    if (dt.JsonRs == "Reload") {

                        $form.hide();

                        $(".AjaxLoader").show();
                        $(".RwRegisterLogin").hide();

                        document.location.reload();
                    }

                    $("#AlertResult").removeClass("alert-error");
                    $("#AlertResult").hide();
                    //$("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);



                    if ($("#register_FbRedirectUrl").length > 0 && $("#register_FbRedirectUrl").val() != "" && $("#register_FbRedirectUrl").val().indexOf("undefined") != -1) {
                        document.location = $("#register_FbRedirectUrl").val();
                    }

                }
                else {

                    $("#AlertResult").removeClass("alert-success");
                    $("#AlertResult").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);
                }

            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });


    $("body").on("click", "a.RegisterIcon, a.LoginIcon, #CheckoutHeader .RegisterIcon a, #CheckoutHeader  .LoginIcon a, #CheckoutHeader  a.RegisterIcon , #CheckoutHeader  a.LoginIcon", function (e) {

        SetStepDataLayer();

        $("#LoginRegisterModal").modal('show');

        if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

            var swparams = GetSwPageParams();
            swparams = ChangeSwHashedStringParamValue(swparams, "ActionType", "SiparisUyelikPopupAcma");
            AddSwAction(swparams);

        }

        if (UseTagManager) {
            AddCheckOutView('', 2);
            SendGaDataLayerVirtual();
        }

        if ($(this).closest("li").hasClass("RegisterIcon") || $(this).hasClass("RegisterIcon")) {

            if ($(".UyeKayitCol").hasClass("pull-right") == false) {

                $(".RegisterInBanner").trigger("click");
            }

        }
        else {
            if ($(".UyeKayitCol").hasClass("pull-right")) {

                $(".RegisterInBanner").trigger("click");
            }
        }

        e.preventDefault();
        return false;
    });

    $("body").on("click", "#ReadAgreement", function (e) {

        $("#AgreementModal .modal-body").html($("#AgreementDetails").html() + $("#OnBilgilendirmetails").html());
        $("#AgreementModal").modal('show');

        return false;
    });

    $("#UserWelcome").on("click", "a.Popup", function (e) {

        $("#LoginRegisterModal").modal('show');

        e.preventDefault();
        return false;
    });


    $("body .LogRegTabs").on("click", "li.tb", function (e) {

        var target = $(this).attr("data-target");

        //console.log(target);

        $(".Tab1, .Tab2").hide();
        $("." + target).show();

        $(".LogRegTabs li").removeClass("active");
        $(this).addClass("active");

        e.preventDefault();
        return false;
    });


    $("body").on("click", ".ForgetPass", function (e) {

        $("#forgottenpassModal").modal('show');

    });

    $("body").on("submit", "form.ForgettenForm", function () {

        $form = $("form.ForgettenForm");

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: 'json',
            success: function (dta) {

                if (dta.Sonuc == true) {

                    $(".ForgettenForm p:first").html(dta.IslemSonucAciklama);

                    $("#email").hide();
                    $("#forgottenPassSubmit").hide();

                    $(".ForgettenForm p:first").removeClass("alert-danger");
                    $(".ForgettenForm p:first").addClass("alert alert-success");

                }
                else {

                    $(".ForgettenForm p:first").html(dta.IslemSonucAciklama);
                    $(".ForgettenForm p:first").addClass("alert alert-danger");
                }



            },
            error: function () {

                alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
            }

        });


        return false;


    });


    //LOGIN & REGISTER END


});